<template>
    <a-modal title="单位信息"
             :width="1000"
             :visible="visible"
             @cancel="$emit('cancel')"
             @ok="$emit('cancel')"
             :maskClosable="false"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <table style="width:80%;height: 380px;"  v-if="en.supplierType === '2'">
            <tr>
                <th>单位名称：</th>
                <td>
                    {{en.enterpriseName}}
                </td>
                <th>社会统一信用代码：</th>
                <td>
                    {{en.enterpriseCode}}
                </td>
            </tr>

            <tr>
                <th>法定代表人：</th>
                <td>
                    {{en.legalPerson}}
                </td>
                <th>法定代表人身份证：</th>
                <td>
                    <span v-if="en.legalIdCard">{{en.legalIdCard.replace(/^(.{6})(?:\d+)(.{4})$/, "$1****$2")}}</span>
                </td>
            </tr>

            <tr>
                <th>联系人：</th>
                <td>
                    {{en.contactsName}}
                </td>
                <th>联系人手机号：</th>
                <td>
                    {{en.contactsPhone}}
                </td>
            </tr>
            <tr>
                <th>注册时间：</th>
                <td>
                    {{en.foundDate}}
                </td>
                <th>注册地址：</th>
                <td>
                    {{en.registerAddress}}
                </td>
            </tr>

            <tr>
                <th>注册资本：</th>
                <td>
                    {{en.registerCapital}} &nbsp;万元
                </td>
                <th>经营范围：</th>
                <td>
                    {{en.businessScope}}
                </td>
            </tr>

            <tr>
                <th>邮箱：</th>
                <td>
                    {{en.email}}
                </td>
                <th>办公电话：</th>
                <td>
                    {{en.tel}}
                </td>
            </tr>

            <tr>
                <th>营业执照扫描件</th>
                <td>
                    <upload-selector
                        :referId='en.cmtId'
                        ref="UploadSelector"
                        :max="1"
                        :readonly="true"
                        value="license"
                        configKey='UCARD'/>
                </td>
                <th>&nbsp;</th>
                <td>&nbsp;</td>
            </tr>
        </table>

        <table style="width:80%;height: 380px;" v-else-if="en.supplierType === '1'" >
            <tr>
                <th>单位名称：</th>
                <td>
                    {{en.enterpriseName}}
                </td>
                <th>注册号：</th>
                <td>
                    {{en.enterpriseCode}}
                </td>
            </tr>

            <tr>
                <th>负责人：</th>
                <td>
                    {{en.legalPerson}}
                </td>
                <th>负责人身份证：</th>
                <td>
                    <span v-if="en.legalIdCard">{{en.legalIdCard.replace(/^(.{6})(?:\d+)(.{4})$/, "$1****$2")}}</span>
                </td>
            </tr>

            <tr>
                <th>手机号：</th>
                <td>
                    {{en.contactsPhone}}
                </td>
                <th>经营范围：</th>
                <td>
                    {{en.businessScope}}
                </td>
            </tr>
            <tr>
                <th>注册时间：</th>
                <td>
                    {{en.foundDate}}
                </td>
                <th>注册地址：</th>
                <td>
                    {{en.registerAddress}}
                </td>
            </tr>

            <tr>
                <th>邮箱：</th>
                <td>
                    {{en.email}}
                </td>
                <th>办公电话/电子邮件：</th>
                <td>
                    {{en.tel}}
                </td>
            </tr>
            <tr>
                <th>
                    营业执照扫描件:
                </th>
                <td>
                    <upload-selector
                            :referId='en.cmtId'
                            ref="UploadSelector"
                            :max="1"
                            :readonly="true"
                            value="license"
                            configKey='UCARD'/>
                </td>
                <th>&nbsp;</th>
                <td>&nbsp;</td>
            </tr>
        </table>
    </a-modal>
</template>

<script>
    import UploadSelector from '@/components/selector/UploadSelector'
    import moment from "moment";

    export default {
        created() {
            this.initInfo()
        },
        components: {
            UploadSelector,
            moment
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                form: this.$form.createForm(this),
                id: this.$route.query.id,
                modalLoading: false,
                loading: false,
                supplier: '',
                en: '',
                selected: []
            }
        },
        methods: {
            initInfo() {
                let that = this
                this.$http.get("/api/v1/supplier/enterprise/init_certifications.json").then(function (res) {
                    if (res.result) {
                        that.en = res.result;
                        if (that.en.foundDate) {
                            that.en.foundDate = moment(that.en.foundDate).format("YYYY/MM/DD")
                        }
                        if (that.en.registerCapital){
                            that.en.registerCapital = that.en.registerCapital + ""
                        }
                    }
                })}
        }
    };
</script>
<style lang="less" scoped>
    .ant-input {
        width: 300px;
    }

    .fx-form th {
        width: 130px;
    }
    /*table {*/
    /*    height: 400px;*/
    /*}*/
    th{
        width: 150px;
    }
    tr{
        height: 70px;
    }
</style>
